import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  TextField,
  Theme,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../utils/LoadingSpinner";
import { Alert } from "@material-ui/lab";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface ICompleteOrderShipmentState {
  message: string;
  open: boolean;
  orderItemId: string;
  purchaseId: string;
  showLoadingSpinner: boolean;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class CompleteOrderShipmentSection extends React.Component<
  any,
  ICompleteOrderShipmentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      message: "",
      open: false,
      orderItemId: "",
      purchaseId: "",
      showLoadingSpinner: false,
    };

    this.handleOrderItemId = this.handleOrderItemId.bind(this);
    this.handlePurchaseId = this.handlePurchaseId.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  public render() {
    return (
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="center"
        spacing={3}
      >
        {this.state.showLoadingSpinner && <LoadingSpinner />}

        <Alert severity="info">
          <p>
            Before triggering complete order shipment, ensure to wait 15 minutes
            after PFW ran successfully —{" "}
            <a
              href="https://w.amazon.com/bin/view/Pharmacy/Public/Teams/APAQ/Portal/CompleteOrderShipment/UserExperience/"
              target="_blank"
              rel="noopener noreferrer"
            >
              check it out!
            </a>
          </p>
        </Alert>

        <Grid item xs>
          <Tooltip
            disableFocusListener
            title="Please find 'Purchase Id' in grass tool!"
          >
            <TextField
              label="Purchase Id (Required)"
              variant="outlined"
              value={this.state.purchaseId}
              onChange={this.handlePurchaseId}
            />
          </Tooltip>
        </Grid>

        <Grid item xs>
          <Tooltip
            disableFocusListener
            title="Please find 'Order Item Id' in grass tool!"
          >
            <TextField
              label="Order Item Id (Required)"
              variant="outlined"
              value={this.state.orderItemId}
              onChange={this.handleOrderItemId}
            />
          </Tooltip>
        </Grid>

        <Grid item xs>
          <Button
            variant="outlined"
            color="default"
            onClick={this.handleSubmit}
          >
            Submit
          </Button>
        </Grid>

        {this.state.message && (
          <Dialog
            open={this.state.open}
            TransitionComponent={TransitionConst}
            keepMounted
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            onClose={this.handleClose}
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Complete Order Shipment Response"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {this.state.message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handleOrderItemId(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ orderItemId: event.target.value });
  }

  public handlePurchaseId(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ purchaseId: event.target.value });
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.purchaseId) {
      alert("Please enter the purchase id");
      formIsValid = false;
    } else if (!this.state.purchaseId.match("\\d{3}-\\d{7}-\\d{7}")) {
      alert("Please enter the valid purchase id.");
      formIsValid = false;
    } else if (!this.state.orderItemId) {
      alert("Please enter the order item id");
      formIsValid = false;
    } else if (!this.state.orderItemId.match("^[0-9]*$")) {
      alert("Please enter the valid order item id.");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ showLoadingSpinner: true });

      const apiName = "ApaqPortalAPI";
      const path = "/order/shipment-complete";
      const config = {
        body: {
          itemId: this.state.orderItemId,
          purchaseId: this.state.purchaseId,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ open: true });
          this.setState({ showLoadingSpinner: false });
          this.setState({
            message:
              'Complete Order Shipment Successful. { "FulfillmentShipmentId":"' +
              response.fulfillmentShipmentId +
              '" }',
          });
          this.setState({ orderItemId: "" });
          this.setState({ purchaseId: "" });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ showLoadingSpinner: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(CompleteOrderShipmentSection);
